import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { StyledFlex } from '@goodfynd/react-web.styles';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';

import Chip from '../../Chip';
import { StyledContainer } from '../styles';
import type { InputRadioChipGroupProps } from '../types';

export default function InputRadioChipGroup<T extends FieldValues>({
  control,
  name,
  css,
  label,
  options,
}: InputRadioChipGroupProps<T>): JSX.Element {
  return (
    <StyledContainer css={css}>
      <Controller<T>
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <FormControl error={!!error} fullWidth>
              <FormLabel component="legend">{label}</FormLabel>
              <StyledFlex css={{ gap: 8, marginTop: 4 }}>
                {options.map((option, index) => (
                  <Chip
                    active={value == option.value}
                    aria-label={String(option.label)}
                    key={index}
                    label={option.label}
                    onClick={() => {
                      onChange(option.value);
                    }}
                  />
                ))}
              </StyledFlex>
              <FormHelperText>{error?.message}</FormHelperText>
            </FormControl>
          );
        }}
      />
    </StyledContainer>
  );
}
